import { MantineThemeOverride } from "@mantine/core";
import tinycolor from "tinycolor2";

function calculateShades(primaryColor: string){
    const baseHSLcolor = tinycolor(primaryColor).toHsl()
    const darkerRatio = (0.95 - baseHSLcolor.l) / 7.0;
    const shadesArray = new Array(10);
    for(let i=0; i<7; i++){
        shadesArray[i] = tinycolor({h: baseHSLcolor.h, s: baseHSLcolor.s, l: .95 - (i * darkerRatio)}).toString('hex6')
    }
    shadesArray[7] = primaryColor
    shadesArray[8] = tinycolor({h: baseHSLcolor.h, s: baseHSLcolor.s, l: .05 + ((baseHSLcolor.l - 0.05) / 2.0)}).toString('hex6');
    shadesArray[9] = tinycolor({h: baseHSLcolor.h, s: baseHSLcolor.s, l: .05}).toString('hex6');
    return shadesArray as [string, string, string, string, string, string, string, string, string, string];
};

const makeVsethTheme = (
	newPrimaryColor?: [
		string,
		string,
		string,
		string,
		string,
		string,
		string,
		string,
		string,
		string
	] | string
) => {
	let newPrColor = undefined;
	if(typeof newPrimaryColor === 'string'){
		newPrColor = calculateShades(newPrimaryColor);
	} else {
		newPrColor = newPrimaryColor
	}

	const vsethTheme: MantineThemeOverride = {
		colors: {
			vsethMain:
			newPrColor !== undefined
					? newPrColor
					: [
							"#E5F9FF",
							"#D1F3FF",
							"#9EE5FF",
							"#6BD8FF",
							"#3DC8FF",
							"#1ABEFF",
							"#00B2FF",
							"#009FE3",
							"#0A8BC7",
							"#0E78AA",
					  ],
			vsethGray: new Array(10).fill("rgb(144, 146, 150)") as any,
		},
		primaryColor: "vsethMain",
		primaryShade: 7,
		fontFamily:
			'"Source Sans Pro",Lato,Arial,Helvetica,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol',
		lineHeight: 1.5,
	};
	return vsethTheme;
};

export default makeVsethTheme;
